import process from "process";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const FEEDBACK_URL = "";
export const TIMEOUT = 50000;

export const DISABLE_PAYMENT = process.env.REACT_APP_DISABLE_PAYMENT;

export const TITLE = process.env.REACT_APP_TITLE;
